<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputContacts" });
import { Button } from "../../../../../../../elements/index.js";
import { ContactForm, FieldsetContact } from "../../../../../../contact/index.js";
import SelectContacts from "../../../../../../contact/modules/select/SelectContacts.svelte";
import { Small } from "../../../../../../../typography/index.js";
export let organizationKey;
export let contactKeys = [];
export let addressType;
let showCreationForm = false;
let newContact = {};
const showForm = () => {
    showCreationForm = true;
};
const getContactType = (addressType2) => {
    if (addressType2 === "main") {
        return "contact";
    }
    if (addressType2 === "invoice") {
        return "invoice";
    }
    return "warehouse";
};
const onCancel = () => {
    showCreationForm = false;
    newContact = { type: getContactType(addressType) };
};
const onContactCreate = (event) => {
    contactKeys = [...contactKeys, event.detail._.key];
    showCreationForm = false;
    newContact = { type: getContactType(addressType) };
};
$: contactParameters = {
    contactType: getContactType(addressType),
    organizationKey
};
$: newContact.type = getContactType(addressType);
</script>

{#if showCreationForm}

    <div class = 's8-label'>
        <Small>New Contact</Small>
    </div>

    <ContactForm
        on:save = { onContactCreate }
        { organizationKey }
        contact = { newContact }
    >
        <FieldsetContact bind:contact = { newContact } showType = { false } />

        <div class = 's8-buttons'>
            <Button
                size = 'xs'
                label = 'Cancel'
                color = 'neutral'
                style = 'outline'
                on:click = { onCancel }
            />
            <Button
                type = 'submit'
                size = 'xs'
                label = 'Create Contact'
                color = 'dark'
                style = 'outline'
            />
        </div>
    </ContactForm>

{:else}

    <SelectContacts parameters = { contactParameters } bind:keys = { contactKeys } />
    <Button
        label = 'Add new contact'
        style = 'outline'
        icon = 'plus'
        align = 'left'
        size = 'xs'
        color = 'dark'
        on:click = { showForm }
    />

{/if}

<style>

    div.s8-label {
        margin-bottom: 15px;
    }

    div.s8-buttons {
        display: flex;
        place-content: space-between;
    }</style>